import React from "react"
import { graphql } from "gatsby"
import { useTranslation } from "gatsby-plugin-react-i18next"

import { Text } from "../../../Text/Text"
import { LocationItem, LocationItemProps } from "../../location-item/LocationItem"


interface OwnProps {
  matchingLocations: LocationItemProps[] | {centerHours: string}[];
  useBiggerHeader: boolean;
}

export type MatchingLocationsProps = OwnProps

export const MatchingLocations: React.FC<MatchingLocationsProps> = ({
  matchingLocations,
  useBiggerHeader
}) => {
  const { t } = useTranslation("shared", {
    keyPrefix: "location_pages.center_lookup",
  });

  return (
    <div className="max-w-content-width mx-auto px-5 py-8 md:py-16">
      <Text variant={useBiggerHeader ? "medium-header": "body"}>{t("matching_locations_title")}</Text>
      <div className="grid md:grid-cols-3 md:gap-5 md:mt-5">
        {matchingLocations?.map((matchingLocation, index) => {
          const d = new Date();
          const weekday = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
          const currentDayOfWeek = weekday[d.getDay()];
          
          const {
            centerHours,
            cityRegionPostal,
            comingSoon,
            googleMapEmbedLink,
            location,
            streetAddress,
            url,
            yearOpening
          } = matchingLocation;
          const todaysHours = centerHours && centerHours[currentDayOfWeek];

          return (
            <LocationItem
              cityRegionPostal={cityRegionPostal}
              comingSoon={comingSoon}
              key={index}
              location={location}
              googleMapEmbedLink={googleMapEmbedLink}
              streetAddress={streetAddress}
              todaysHours={todaysHours}
              url={url}
              yearOpening={yearOpening}
            />
          )
        })}
      </div>
    </div>
  )
}
